import { useSelector } from 'react-redux'
import CoachDashboardQuickActions from './CoachDashboardQuickActions'
import CoachDashboardProgramsOverview from './CoachDashboardProgramsOverview'
import CoachDashboardCalendar from './CoachDashboardCalendar'
import CoachDashboardSchedule from './CoachDashboardSchedule'
import CoachDashboardSupport from './CoachDashboardSupport'
import GenericFeedComponent from '../../classes/program-dashboard-manager/overview-tab/GenericFeedComponent'
import { selectIsOnboardingEnabled } from '../../../reducers/coachOnboardingReducer'
import CoachOnboardingWidget from './coachOnboarding/CoachOnboardingWidget'

import styles from './CoachDashboardHome.module.scss'

const CoachDashboardHome = () => {
  const isCoachOnboardingEnabled = useSelector(selectIsOnboardingEnabled)
  const { id: communityId } = useSelector(state => state.user.current_user.communities[0])

  return (
    <div className={styles.coachDashboardHome}>
      {isCoachOnboardingEnabled ? <CoachOnboardingWidget /> : <GenericFeedComponent id={communityId} type='community'/>}
      <div className={styles.dashboardContent}>
        <CoachDashboardQuickActions communityId={communityId}/>
        <div className={styles.dashboardWidgetWrapper}>
          <div>
            <CoachDashboardCalendar/>
            <CoachDashboardProgramsOverview communityId={communityId}/>
          </div>
          <div>
            <CoachDashboardSchedule />
            <CoachDashboardSupport/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CoachDashboardHome
